<template>
  <div>
    <admin v-if="$store.getters['isAdmin']"></admin>
    <country v-if="!$store.getters['isAdmin']"></country>
  </div>
</template>

<script>
  import admin from "@/components/manageQuestionnaires/adminQuestionnaires.vue";
  import country from "@/components/manageQuestionnaires/countryQuestionnaires.vue";
  export default {
    components: {
      admin,
      country
    },
  }
</script>
